var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4989 20.0006C29.4989 20.5978 29.2709 21.1951 28.8159 21.6506L14.4829 35.9832C13.5712 36.8949 12.093 36.8949 11.1816 35.9832C10.2702 35.0718 10.2702 33.5939 11.1816 32.6821L23.864 20.0006L11.1825 7.3187C10.2711 6.40733 10.2711 4.92917 11.1825 4.01788C12.0938 3.10569 13.5716 3.10569 14.4834 4.01788L28.8164 18.3502C29.2713 18.8059 29.4989 19.4032 29.4989 20.0006Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight40Px);
export default ForwardRef;